<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-12"><a id="_idTextAnchor012"></a>Brat Gospel</h2>
<p class="Verse-new">A teenage mum, her little brat</p>
<p class="Verse-main">born loving, crucified, cut down.</p>
<p class="Verse-main">Glory all around.</p>
<p class="Verse-new">Such goings-on </p>
<p class="Verse-main">survive as symbols: slain lamb,</p>
<p class="Verse-main">a sickle, an all-seeing eye.</p>
<p class="Verse-new">Heavy lumps of history</p>
<p class="Verse-main">blacken the surrounding sky.</p>
<p class="Verse-main">Blind giants with feet of clay.</p>
<p class="Verse-new">Looking on</p>
<p class="Verse-main">we hear the heartfelt cry:</p>
<p class="Verse-main">make way for the royal lamb!</p>
<p class="Verse-new">The eye compassionate, </p>
<p class="Verse-main">visionary of the Christ-life</p>
<p class="Verse-main">rooted in the hearts of all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-14.vue?4229cf87